import { collection, onSnapshot, query, where } from "firebase/firestore";
import { HOME_PATH } from "../vatar/env";
import { db } from "../firebase";

export const checkPlayerStatus = (roomId, userId) => {
  if (!roomId || !userId) return;

  const q = query(collection(db, "rooms"), where("roomId", "==", roomId));

  return onSnapshot(q, (querySnapshot) => {
    if (querySnapshot.empty) {
      // Room doesn't exist
      alert("This room no longer exists.");
      localStorage.removeItem("currentRoomId");
      localStorage.removeItem("currentUserId");
      localStorage.removeItem("playerName");
      window.location.href = HOME_PATH;
      return;
    }

    const roomData = querySnapshot.docs[0].data();
    const isPlayerInRoom = roomData.players.some(
      (player) => player.id === userId
    );

    if (!isPlayerInRoom) {
      // Player was removed
      alert("You have been removed from this room by the host.");
      localStorage.removeItem("currentRoomId");
      localStorage.removeItem("currentUserId");
      localStorage.removeItem("playerName");
      window.location.href = HOME_PATH;
    }
    
  });
};
